<template>
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(salvar)">
            <h6 class="mb-3 text-left">
                Edite e salve os dados gerais do Contrato / Ordem de Fornecimento
                <b-button class="float-right m-1" size="sm" type="submit">
                    <font-awesome-icon icon="save" />
                    Salvar
                </b-button>
            </h6>
            <b-row class="w-100">
                <b-col cols="12" md="6">
                    <b-row class="d-flex align-items-start">
                        <b-col cols="6">
                            <default-form-validation-provider label="Número" v-slot="defaultState">
                                <b-form-input id="input-numero" v-model="contrato.NrContrato" :state="defaultState.state"
                                    rules="max:8">
                                </b-form-input>
                            </default-form-validation-provider>
                        </b-col>
                        <b-col cols="2" class="d-flex justify-content-center align-items-center mt-4 pt-2">
                            <span class="h2">/</span>
                        </b-col>
                        <b-col cols="4">
                            <default-form-validation-provider label="Ano" v-slot="defaultState">
                                <b-form-input id="input-ano" v-model="contrato.NrAnoContrato" :state="defaultState.state"
                                    type="number"></b-form-input>
                            </default-form-validation-provider>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Tipo" v-slot="defaultState">
                        <b-form-select id="select-tipo" v-model="contrato.IdTipoContrato" :options="listaTipoContrato"
                            :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Objeto" v-slot="defaultState" rules="max:1000">
                        <b-form-textarea id="input-objeto-contrato" :state="defaultState.state"
                            v-model="contrato.DeObjetoContrato" rows="3" max-rows="6"></b-form-textarea>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Data de Assinatura" v-slot="defaultState">
                        <b-form-datepicker id="input-data-assinatura" :state="defaultState.state"
                            v-model="contrato.DtAssinatura" v-bind="datePickerProps">
                        </b-form-datepicker>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Data de Publicação" rules="" v-slot="defaultState">
                        <b-form-datepicker id="input-data-publicacao" :state="defaultState.state"
                            v-model="contrato.DtPublicacao" v-bind="datePickerProps">
                        </b-form-datepicker>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Início de Vigência" v-slot="defaultState">
                        <b-form-datepicker id="input-data-inicio-vigencia" :state="defaultState.state"
                            v-model="contrato.DtInicioVigencia" v-bind="datePickerProps">
                        </b-form-datepicker>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Fim de Vigência" v-slot="defaultState">
                        <b-form-datepicker id="input-fim-vigencia" :state="defaultState.state"
                            v-model="contrato.DtFimVigencia" v-bind="datePickerProps">
                        </b-form-datepicker>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider v-if="tipoArquivo === 'salvo'"
                        label="Arquivo Texto do Contrato / Ordem de Fornecimento (PDF)" rules="">
                        <span v-if="contrato && contrato.ArquivoTextoContrato">Nome: {{
                            contrato.ArquivoTextoContrato.DeNomeArquivo }}</span>
                        <div class="d-flex justify-content-center">
                            <btn-download class="mr-2" :fazerDownload="baixarAnexo"
                                :parametros="contrato.ArquivoTextoContrato" />
                            <b-link class="text-dark" @click="removerArquivoEdital()">
                                <font-awesome-icon icon="times" />
                                <div style="font-size: 12px">Remover</div>
                            </b-link>
                        </div>
                    </default-form-validation-provider>
                    <default-form-validation-provider v-else label="Arquivo Texto do Contrato / Ordem de Fornecimento (PDF)"
                        v-slot="defaultState">
                        <b-form-file v-model="contrato.ArquivoTextoContrato" placeholder="Nenhum arquivo selecionado"
                            accept="application/pdf" :state="defaultState.state"></b-form-file>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Procedimento de Origem" v-slot="defaultState" :rules="disabledProcedimentoOrigem ? '' : 'required'">
                        <b-form-select id="select-procedimento-origem" v-model="contrato.FlTipoProcedOrigem"
                            :options="listaProcedimentoOrigem" :state="defaultState.state" :disabled=disabledProcedimentoOrigem>
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <editar-procedimento-origem-dispensa v-if="['B','D','F'].includes(contrato.FlTipoProcedOrigem)" :ctr="contrato" @procedimentoOrigemAtualizado="procedimentoOrigemAtualizado" />
                <editar-procedimento-origem-contrato-centralizado v-if="contrato.FlTipoProcedOrigem === 'C'" :ctr="contrato" @procedimentoOrigemAtualizado="procedimentoOrigemAtualizado"/>
                <editar-procedimento-origem-registro-preco v-if="contrato.FlTipoProcedOrigem === 'R'" :ctr="contrato" @procedimentoOrigemAtualizado="procedimentoOrigemAtualizado"/>
                <editar-procedimento-origem-licitacao-propria v-if="contrato.FlTipoProcedOrigem === 'P'" :ctr="contrato" @procedimentoOrigemAtualizado="procedimentoOrigemAtualizado"/>
                <editar-procedimento-origem-licitacao-outra-ug v-if="contrato.FlTipoProcedOrigem === 'U'" :ctr="contrato" @procedimentoOrigemAtualizado="procedimentoOrigemAtualizado"/>
            </b-row>
        </b-form>
    </validation-observer>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { ValidationObserver } from "vee-validate"
import { eventBus } from '@/main';
import BtnDownload from '@/components/shared/btn-download.vue'
import { DatePickerDefaultProps, FormGroupDefaultCols } from '@/types/form-default-props'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import contratoService from '@/services/licitacoes/contratoService'
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import { SelectValue } from '@/types/select-value'
import { ArquivoContrato } from '@/types/licitacoes/contratos/arquivo-contrato'
import EditarProcedimentoOrigemDispensa from '@/components/licitacoes/contratos/editar-contrato/EditarProcedimentoOrigemDispensa.vue'
import EditarProcedimentoOrigemContratoCentralizado from '@/components/licitacoes/contratos/editar-contrato/EditarProcedimentoOrigemContratoCentralizado.vue'
import EditarProcedimentoOrigemRegistroPreco from '@/components/licitacoes/contratos/editar-contrato/EditarProcedimentoOrigemAtaRegistroPreco.vue'
import EditarProcedimentoOrigemLicitacaoPropria from '@/components/licitacoes/contratos/editar-contrato/EditarProcedimentoOrigemLicitacaoPropria.vue'
import EditarProcedimentoOrigemLicitacaoOutraUg from '@/components/licitacoes/contratos/editar-contrato/EditarProcedimentoOrigemLicitacaoOutraUg.vue'

const CompProps = Vue.extend({
    name: 'AbaEditarDadosIniciaisContrato',
    components: { 
                  BtnDownload, DefaultFormValidationProvider, ValidationObserver, 
                  EditarProcedimentoOrigemDispensa, EditarProcedimentoOrigemContratoCentralizado, 
                  EditarProcedimentoOrigemRegistroPreco, EditarProcedimentoOrigemLicitacaoPropria, EditarProcedimentoOrigemLicitacaoOutraUg
                },
    props: {
        ctr: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class AbaEditarDadosIniciaisContrato extends mixins(UtilsTS, CompProps) {
    @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
    datePickerProps = DatePickerDefaultProps
    formGroupCols = FormGroupDefaultCols
    valorPadraoSelect: SelectValue = { value: null, text: 'SELECIONE UMA OPÇÃO', disabled: true }
    listaTipoContrato: SelectValue[] = [this.valorPadraoSelect]
    listaProcedimentoOrigem: SelectValue[] = [this.valorPadraoSelect]
    contrato: Contrato = new Contrato()
    tipoArquivo: string | null = null

    get disabledProcedimentoOrigem() {
        if (this.contrato.IdTipoContrato == null || this.contrato.IdTipoContrato == 1) {
            this.contrato.FlTipoProcedOrigem = null
            return true
        }
        return false
    }

    procedimentoOrigemAtualizado(contratoAtualizado: Contrato) {
        this.contrato = contratoAtualizado;
    }

    limparProcedimentoOrigem(): void {
        this.contrato.FlTipoProcedOrigem = null
    }
    /** Validar e salvar dados iniciais de novo contrato */
    async salvar(): Promise<void> {
        store.blockScreen = true
        try {
            const isValid = await this.validationobserver.validate();
            if (!isValid) {
                console.error(this.validationobserver)
            } else {
                //salvar o contrato 
                const retorno = await contratoService.salvarDadosIniciais(this.contrato)
                this.$emit('atualizarContrato', retorno)
                this.$toast.success(`Os dados iniciais do contrato/ordem de fornecimento foram salvos!`)
                //vamos atualizar a instância local de licitação, para que o File se comporte corretamente.
                // se isto não funcionar, o ideal é o componente pai forçar um rerender deste aqui.
                this.contrato = retorno
                this.contrato.tratarDadosDaAPI()
                this.tipoArquivo = this.contrato.getTipoArquivo()
                eventBus.$emit('atualizar-status-contrato', retorno.CdSituacao)
            }
        } catch (e: any) {
            this.tratarError(e, true)
        } finally {
            store.blockScreen = false
        }
    }

    async montarCombos(): Promise<void> {
        const response = await contratoService.getCombos()
        this.listaTipoContrato.push(...response.tipos
            .map(t => {
                return { value: t.IdTipoContrato, text: t.DeTipoContrato }
            }))
        this.listaProcedimentoOrigem.push(...response.procedimentos.map(p => {
            return { value: p.SgTipoProcedimentoOrigem, text: p.DeTipoProcedimentoOrigem }
        }))
    }
    async baixarAnexo(arquivo: ArquivoContrato) {
        const response = await contratoService.baixarAnexo(String(arquivo.IdArquivo))
        this.download(`edital-${this.contrato.NumeroAnoContrato}`, response.data)
    }
    removerArquivoEdital() {
        this.contrato.ArquivoTextoContrato = undefined
        this.tipoArquivo = this.contrato.getTipoArquivo()
    }
    async mounted() {
        try {
            if (this.ctr.IdContrato > 0) {
                this.contrato = this.ctr
                this.contrato.tratarDadosDaAPI()
                this.tipoArquivo = this.contrato.getTipoArquivo()
            }
            store.blockScreen = true
            await this.montarCombos()
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarDadosIniciaisContrato', e)
        } finally {
            store.blockScreen = false
        }
    }
}


</script>

<style></style>